import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { sortBySortOrder, swapSortOrder, type SortableItem } from '../utils/sortOrderList';

type UseSortOrderReorderOptions<T extends SortableItem> = {
  items: T[];
  canReorder?: boolean;
  isSibling?: (left: T, right: T) => boolean;
  updateItem: (item: T, sortOrder: number) => Promise<void>;
  onReordered: () => Promise<void>;
};

export function useSortOrderReorder<T extends SortableItem>({
  items,
  canReorder = true,
  isSibling,
  updateItem,
  onReordered,
}: UseSortOrderReorderOptions<T>) {
  const [moving, setMoving] = useState(false);
  const sortedItems = useMemo(() => sortBySortOrder(items), [items]);

  async function move(index: number, direction: 'up' | 'down'): Promise<void> {
    if (!canReorder || moving) {
      return;
    }

    setMoving(true);
    try {
      await swapSortOrder(sortedItems, index, direction, updateItem, isSibling);
      await onReordered();
    } catch {
      toast.error('Falha ao reordenar.');
    } finally {
      setMoving(false);
    }
  }

  return {
    sortedItems,
    moving,
    move,
  };
}
